<router-outlet></router-outlet>
<app-cookie-banner />
